import React from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

const Container = styled.div`
  background: white;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const Title = styled.p`
  cursor: 'default';
  color: ${props => props.theme.primary};
  font-size: 0.8rem;
  font-weight: bold;
  line-height: 1.5;
  margin: 1.25em 0;
  text-align: center;
  transition: filter 0.25s;

  &:hover {
    filter: brightness(1.2);
  }

  @media (min-width: 375px) {
    font-size: 0.9rem;
  }

  @media (min-width: 768px) {
    font-size: 1rem;
  }

  .br1 {
    display: none;
  }

  .br2 {
    @media (min-width: 768px) {
      display: none;
    }
  }
`;

const Announcement = () => {
  return (
    <Container>
      <Title>
        <Translate
          id="landingPage.announcement.title"
          options={{ renderInnerHtml: true }}
        />
      </Title>
    </Container>
  );
};

Announcement.defaultProps = {
  confirm: false
};

export default Announcement;
